enum STATUS {
	LIVE = 'Live',
	REVIEW = 'Review',
	APPROVED = 'Approved',
}

export default STATUS;

export function getNextStatus(status: STATUS) {
	if (status === STATUS.LIVE) return STATUS.REVIEW;
	return STATUS.APPROVED;
}

export function getPrevStatus(status: STATUS) {
	if (status === STATUS.APPROVED) return STATUS.REVIEW;
	return STATUS.LIVE;
}

export function hasNextStatus(status: STATUS): boolean {
	if (status === STATUS.APPROVED) return false;
	return true;
}

export function hasPrevStatus(status: STATUS): boolean {
	if (status === STATUS.LIVE) return false;
	return true;
}

export function getNextLabel(status: STATUS): string | undefined {
	if (status === STATUS.LIVE) return getButtonLabel(STATUS.REVIEW);
	if (status === STATUS.REVIEW) return getButtonLabel(STATUS.APPROVED);
	return undefined;
}

export function getPrevLabel(status: STATUS): string | undefined {
	if (status === STATUS.APPROVED) return getButtonLabel(STATUS.REVIEW);
	if (status === STATUS.REVIEW) return getButtonLabel(STATUS.LIVE);
	return undefined;
}

function getButtonLabel(status: STATUS): string | undefined {
	if (status === STATUS.LIVE) return 'To Live';
	if (status === STATUS.REVIEW) return 'To Review';
	if (status === STATUS.APPROVED) return 'To Approved';
	return undefined;
}

export function getLabelTranslationKey(status: STATUS): string {
	if (status === STATUS.LIVE) return 'shoppingCart:OPEN';
	if (status === STATUS.REVIEW) return 'shoppingCart:IN_REVIEW';
	if (status === STATUS.APPROVED) return 'shoppingCart:CLOSED';
	return '';
}
